module.exports = __webpack_public_path__ + "img/logobe.4ce6e29c.png";